export default "/_next/static/images/2bbcc3ebcefe218369656a681ea0edbe.jpg";